import React from 'react';
import { Notification, NotificationGroup } from '@progress/kendo-react-notification';
import AuthService from "../services/AuthService";
import UserPreferenceEditForm from './UserPreferenceEditForm';
import {withRouter} from 'react-router';
import ConfigService from "../services/ConfigService";
import styles from './UserPreferencePage.module.scss';

class UserPreferencePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            preferences: {   
                id: 0, 
                identity: "",
                email: "",
                name: "",
                phone: "",
                mobile: "",
                address: {   
                    Address: {
                        Id: 0, 
                        Addr: null,
                        address_type: {description: "", value: ""},
                        suburb: { name: "", pcode: "", depot: { code:"", name:""} }, 
                        Address1: "", 
                        Address2: "",
                        Name: ""
                    },
                    Contact: { Name: "", Mobile : "", Email: "", Phone: "" },             
                    Instruction: ""
                }
            },
            config: {
                termsAndConditions: {
                    // default but will be overriden by config
                    generalUrl: "http://www.fliway.com/media/5413/fliway-termsandconditions-dec17.pdf?GenDefault",
                    userAndPrivacyUrl: "http://www.fliway.com/media/5413/fliway-termsandconditions-dec17.pdf?UsrDefault"
                }
            }
        };
    }

    getUser = async () => {
        if(!this.authService)
            this.authService = await AuthService.getInstance();
        return await this.authService.getAuthenticatedUser(true);
    }

    async componentDidMount() {     
        this.setState({
            alertColor: "info",
            alertMessage: "",
            alertVisible: false
        });

        let configTask = ConfigService.getConfig();
        var user = await this.getUser();
        if(user === null)
            return;
        if (user && user.profile) {
            console.log('user.profile.email', user.profile.email);
            //email should always come from profile
            this.setState({
                preferences: {...this.state.preferences, email: user.profile.email || this.state.preferences.email, address: {...this.state.preferences.address, Contact: {...this.state.preferences.address.Contact, Email: user.profile.email}}}
            });
        }
        let config = await configTask;
        this.setState({config: {...this.state.config, ...config}});
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', `Bearer ${user.access_token}`);

        window.fetch('api/UserPreferences/MyPreferences', {
            method: 'GET',
            headers: headers
            })
            .then(async response => {
                console.log(response);
                if (response.status === 200)
                    return response.json().catch(function(reason) {
                        alert('Error parsing your preferences', reason);
                    });
                else {
                    var user = await this.getUser();
                    console.log('Setting prefs from user', user.profile);
                    if (user && user.profile) {
                        this.setState({
                            loaded: true,
                            preferences: {
                                ...this.state.preferences,
                                identity: user.profile.sub || this.state.preferences.identity,
                                email: user.profile.email || this.state.preferences.email,
                                address: {...this.state.preferences.address, Contact: {...this.state.preferences.address.Contact, Email: user.profile.email}}
                            }
                        });
                    }                    
                    return Promise.reject("Not found");
                }
            })
            .then(data => {
                //console.log('preferences', this.state.preferences);
                //console.log('data', data);
                var newPrefs = {...this.state.preferences, ...data, address: {...this.state.preferences.address}};
                //console.log('new prefs', newPrefs);
                this.setState({
                    loaded: true,
                    preferences: newPrefs
                });
            })
            .catch(error => {
                if(error != "Not found"){
                    console.error('Error retrieving your preferences', error);
                    alert('Error retrieving your preferences', error);
                }
            });
    }

    preferencesUpdated = (newPreferences) => {
        this.setState({preferences: newPreferences});
    }

    handleSubmit = async () => {
        this.props.setGlobalBusy();
        var user = await this.getUser();

        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', `Bearer ${user.access_token}`);
        console.log('posting', this.state.preferences);
        window.fetch('api/UserPreferences/MyPreferences', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(this.state.preferences)
            })
            .then(async response => {
                if (response.status === 200) {
                    return response.json();
                }
                else if(response.status == 500) {
                    var problem  = await response.json();
                    console.log('Problem from server', problem);
                    if(problem.detail)
                        alert(problem.detail);
                }
                else {
                    console.log('Error in response: ', response);
                    this.props.clearGlobalBusy();
                }
            })
            .then(data => {
                var preferences = this.state.preferences;
                preferences.id = data.id;
                this.setState({
                    preferences: preferences
                });

                this.showAlert("success", "Saved");
                this.props.clearGlobalBusy();
                if(data.historyUnavailable !== true)
                    this.props.history.push("/shipments");
            })
            .catch(error => {
                console.log('error, clearing global busy', error);
                this.props.clearGlobalBusy();
            });
    }

    showAlert = (color, message) => {
        this.setState({
            alertColor: color,
            alertMessage: message,
            alertVisible: true
        })
    }

    onDismiss = () => {
        this.setState({
            alertMessage: "",
            alertVisible: "",
            alertColor: "info"
        });
    }    

    render() {

        if (!this.state.loaded)
            return null;

        return (
            <div className="view-body">
                <div className="notificationPanel">
                    <NotificationGroup
                        style={{
                            top: 0,
                            left: '50%',
                            transform: 'translateX(-50%)',
                            alignItems: 'flex-start',
                            flexWrap: 'wrap-reverse'
                        }}
                        >
                        {
                            this.state.alertVisible &&
                            <Notification
                                type={{ style: 'success', icon: true }}
                                closable={true}
                                onClose={() => this.setState({ alertVisible: false })}
                                >
                                {this.state.alertMessage}
                            </Notification>
                        }
                    </NotificationGroup>
                </div>
                {
                    (async () => await this.getUser()) &&
                    <UserPreferenceEditForm
                        busy={this.props.busy}
                        preferences={this.state.preferences}
                        config={this.state.config}
                        handleSubmit={this.handleSubmit}
                        onChange={(e) => this.preferencesUpdated(e)}
                        />
                }
                
            </div>
        );
    }
}

export default withRouter(UserPreferencePage);